<template>
<div class='fw-form-input__wrapper'
     :class='{ "h-flex-1-0": flexAutoWidth }'
     :style='{ width }'>
    <label
        class='fw-form-input__label'
        :class='[
            labelType,
            labelClass,
            {
                "fw-form-input-label--error": fieldHasError
            }]'>
        {{ title }}
    </label>
    <slot></slot>
</div>
</template>

<script lang='ts'>
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import FwInput from './FwInput.vue';

const LABEL_TYPES: Array<string> = ['label-base', 'label-medium', 'label-thin', 'label-small'];

@Component({
    components: {
        FwInput,
    },
})
export default class FwFormInput extends Vue {
    @Prop({ type: String, required: true }) readonly title!: string;
    @Prop({ type: String, default: 'auto' }) readonly width!: string;
    @Prop({ type: String, default: null }) readonly labelClass!: string;
    @Prop({ type: Boolean, default: false }) readonly flexAutoWidth!: boolean;
    @Prop({ type: Boolean, default: false }) readonly fieldHasError!: boolean;
    @Prop({ type: String, default: 'label-base', validator: (size: string) => LABEL_TYPES.includes(size) })
    readonly labelType!: string;
}
</script>

<style lang='sass'>
.fw-form-input
    &__wrapper
        display: block

    &__label
        margin-bottom: 10px
        display: block

        &.label-base
            color: $main-gray
            font-weight: 500
            text-transform: uppercase
            font-size: 14px

        &.label-thin
            color: $alt-blue
            font-size: 16px
            font-weight: 500
        &.label-medium
            color: $alt-blue
            font-size: 14px
            font-weight: 500
        &.label-small
            color: $alt-blue
            font-weight: 500
            text-transform: capitalize
            font-size: 14px

        &--error
            color: $main-red
</style>
